import * as React from 'react';



export default class EmptyDiaryWhiteBg extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" width="204" height="199" viewBox="0 0 204 199">
            <defs>
                <path id="xvocx6e23a" d="M0.331 80.458L46.232 80.458 22.691 0.396z"/>
                <path id="3u61evpq1d" d="M20.756.233c-1.067 0-1.973.782-2.123 1.836L.021 118.639c-.013.09-.021.178-.021.266v.071c.019 1.142.956 2.096 2.144 2.096h156.31c1.07 0 1.974-.783 2.124-1.836L179.19 2.666c.183-1.285-.82-2.433-2.123-2.433H20.757z"/>
                <path id="hje01brtdg" d="M2.672 0.448L0.047 17.944 17.931 17.944 20.556 0.448z"/>
                <path id="npkjb4e9uj" d="M3.076 0.448L0.544 17.944 17.789 17.944 20.321 0.448z"/>
                <path id="66p7lp411l" d="M2.931 0.448L0.306 17.944 18.191 17.944 20.815 0.448z"/>
                <path id="3qd9g4083n" d="M2.674 0.448L0.048 17.944 17.932 17.944 20.557 0.448z"/>
                <path id="swgwwlv2tp" d="M3.056 0.013L0.526 17.508 17.771 17.508 20.302 0.013z"/>
                <path id="5zv4e476nr" d="M2.912 0.013L0.287 17.508 18.171 17.508 20.796 0.013z"/>
                <path id="9wrbn09aot" d="M2.654 0.013L0.029 17.508 17.913 17.508 20.538 0.013z"/>
                <path id="9ud9sqa28w" d="M3.058 0.013L0.527 17.508 17.773 17.508 20.303 0.013z"/>
                <path id="n9p6dnh50y" d="M2.892 0.102L0.268 17.598 18.152 17.598 20.777 0.102z"/>
                <path id="cm4nzwoetA" d="M2.635 0.102L0.009 17.598 17.894 17.598 20.518 0.102z"/>
                <path id="he6b5idwgC" d="M3.04 0.102L0.508 17.598 17.753 17.598 20.285 0.102z"/>
                <path id="ph86j4vypE" d="M2.894 0.102L0.269 17.598 18.153 17.598 20.778 0.102z"/>
                <linearGradient id="44xvb9mlbb" x1="50%" x2="50%" y1="0%" y2="150.52%">
                    <stop offset="0%" stopColor="#ECEFF1"/>
                    <stop offset="100%" stopColor="#FFF"/>
                </linearGradient>
                <linearGradient id="1xv6k8lqhe" x1="50%" x2="50%" y1="0%" y2="273.1%">
                    <stop offset="0%" stopColor="#FFF"/>
                    <stop offset="100%" stopColor="#F3F3F3"/>
                </linearGradient>
                <linearGradient id="t8cci7h29h" x1="50%" x2="50%" y1="0%" y2="97.579%">
                    <stop offset="0%" stopColor="#FFD4D4" stop-opacity=".717"/>
                    <stop offset="100%" stopColor="#F6F7F8"/>
                </linearGradient>
                <linearGradient id="kuendxvhku" x1="50%" x2="50%" y1="0%" y2="97.579%">
                    <stop offset="0%" stopColor="#FFD4D4" stop-opacity=".717"/>
                    <stop offset="100%" stopColor="#F6F7F8"/>
                </linearGradient>
                <linearGradient id="zdbjlrhgiG" x1="50%" x2="50%" y1="100%" y2="0%">
                    <stop offset="0%" stopColor="#E2E5E7"/>
                    <stop offset="100%" stopColor="#FFF"/>
                </linearGradient>
                <linearGradient id="jw5jtlq7rH" x1="50%" x2="50%" y1="0%" y2="74.191%">
                    <stop offset="0%" stopColor="#EAEFF2"/>
                    <stop offset="100%" stopColor="#FFF" stop-opacity="0"/>
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(156.574 1.82)">
                                        <mask id="83t0wnrf4c" fill="#fff">
                                            <use xlinkHref="#xvocx6e23a"/>
                                        </mask>
                                        <path fill="url(#44xvb9mlbb)" d="M0.331 80.458L46.232 80.458 22.691 0.396z" mask="url(#83t0wnrf4c)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013)">
                                        <mask id="wli74uqnwf" fill="#fff">
                                            <use xlinkHref="#3u61evpq1d"/>
                                        </mask>
                                        <path fill="url(#1xv6k8lqhe)" d="M20.756.233c-1.067 0-1.973.782-2.123 1.836L.021 118.639c-.013.09-.021.178-.021.266v.071c.019 1.142.956 2.096 2.144 2.096h156.31c1.07 0 1.974-.783 2.124-1.836L179.19 2.666c.183-1.285-.82-2.433-2.123-2.433H20.757z" mask="url(#wli74uqnwf)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(27.31 81.928)">
                                        <mask id="hp6ykcdfli" fill="#fff">
                                            <use xlinkHref="#hje01brtdg"/>
                                        </mask>
                                        <path fill="url(#t8cci7h29h)" d="M2.672 0.448L0.047 17.944 17.931 17.944 20.556 0.448z" mask="url(#hp6ykcdfli)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(60.991 81.928)">
                                        <mask id="vxmga2vo8k" fill="#fff">
                                            <use xlinkHref="#npkjb4e9uj"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M3.076 0.448L0.544 17.944 17.789 17.944 20.321 0.448z" mask="url(#vxmga2vo8k)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(94.673 81.928)">
                                        <mask id="4b116dvmum" fill="#fff">
                                            <use xlinkHref="#66p7lp411l"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.931 0.448L0.306 17.944 18.191 17.944 20.815 0.448z" mask="url(#4b116dvmum)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(129.265 81.928)">
                                        <mask id="sr70qarcwo" fill="#fff">
                                            <use xlinkHref="#3qd9g4083n"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.674 0.448L0.048 17.944 17.932 17.944 20.557 0.448z" mask="url(#sr70qarcwo)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(30.95 49.157)">
                                        <mask id="oqexa39aeq" fill="#fff">
                                            <use xlinkHref="#swgwwlv2tp"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M3.056 0.013L0.526 17.508 17.771 17.508 20.302 0.013z" mask="url(#oqexa39aeq)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(65.543 49.157)">
                                        <mask id="nszqxbbn8s" fill="#fff">
                                            <use xlinkHref="#5zv4e476nr"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.912 0.013L0.287 17.508 18.171 17.508 20.796 0.013z" mask="url(#nszqxbbn8s)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(99.224 49.157)">
                                        <mask id="ugn87ewn1v" fill="#fff">
                                            <use xlinkHref="#9wrbn09aot"/>
                                        </mask>
                                        <path fill="url(#kuendxvhku)" d="M2.654 0.013L0.029 17.508 17.913 17.508 20.538 0.013z" mask="url(#ugn87ewn1v)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(132.906 49.157)">
                                        <mask id="koe4idwgex" fill="#fff">
                                            <use xlinkHref="#9ud9sqa28w"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M3.058 0.013L0.527 17.508 17.773 17.508 20.303 0.013z" mask="url(#koe4idwgex)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(35.502 16.386)">
                                        <mask id="354osgw5pz" fill="#fff">
                                            <use xlinkHref="#n9p6dnh50y"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.892 0.102L0.268 17.598 18.152 17.598 20.777 0.102z" mask="url(#354osgw5pz)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(70.094 16.386)">
                                        <mask id="e3jqxk7n5B" fill="#fff">
                                            <use xlinkHref="#cm4nzwoetA"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.635 0.102L0.009 17.598 17.894 17.598 20.518 0.102z" mask="url(#e3jqxk7n5B)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(103.776 16.386)">
                                        <mask id="7mpzefxmvD" fill="#fff">
                                            <use xlinkHref="#he6b5idwgC"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M3.04 0.102L0.508 17.598 17.753 17.598 20.285 0.102z" mask="url(#7mpzefxmvD)"/>
                                    </g>
                                    <g transform="translate(-257 -337) translate(220 337) translate(37) translate(0 10.013) translate(137.457 16.386)">
                                        <mask id="jd3rl3kn2F" fill="#fff">
                                            <use xlinkHref="#ph86j4vypE"/>
                                        </mask>
                                        <path fill="#E9EDEF" d="M2.894 0.102L0.269 17.598 18.153 17.598 20.778 0.102z" mask="url(#jd3rl3kn2F)"/>
                                    </g>
                                </g>
                                <path fill="url(#zdbjlrhgiG)" d="M71.55 0c1.021 0 1.848.827 1.848 1.848 0 .102-.008.205-.025.306l-2.188 12.988c-.21 1.243-1.286 2.154-2.547 2.154-1.02 0-1.848-.827-1.848-1.848 0-.102.009-.205.026-.306l2.187-12.988C69.213.911 70.29 0 71.551 0zM125.26 0c1.02 0 1.847.827 1.847 1.848 0 .102-.009.205-.026.306l-2.187 12.988c-.21 1.243-1.287 2.154-2.548 2.154-1.02 0-1.847-.827-1.847-1.848 0-.102.008-.205.025-.306l2.188-12.988C122.922.911 123.998 0 125.259 0z" transform="translate(-257 -337) translate(220 337) translate(37)"/>
                            </g>
                            <path fill="url(#jw5jtlq7rH)" d="M197 199c0-31.48-43.205-57-96.5-57S4 167.52 4 199" transform="translate(-257 -337) translate(220 337) translate(37)"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
  }
}
